import { useRouter } from 'next/router';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  ARTICLES_NEWS_URL,
  ZEEKANNADA_NEWS_URL
} from 'src/utils/constants/ApiConstants';
import { NavMenuLinks } from 'src/utils/constants/RouterConstants';
import { DEVICE_WIDTH_CONSTANTS } from 'src/utils/constants/utilConstants';

import {
  anchorTagUrlGenerator,
  getActiveMenuItem,
  getMenuDetails,
  navMenuMixpanelEvent,
  removeTelcoUserMenuList
} from './NavMenuHandler';
import {
  menuItemsWrapper,
  moreMenuStyle,
  navMenuWrapper,
  redDot,
  selectedItemStyle
} from './NavMenuStyle';
import { getSessionStorage } from '../../utils/browserStorageHandler';
import { globalUrlHelper, isServer } from '../../utils/common';
import { DynamicObject } from '../../utils/commonTypes';
import { PARTNER_NAME } from '../../utils/constants/localStorageConstants';
import {
  NavMenuElements,
  NavMenuItemDescription,
  PartnerPlatforms
} from '../../utils/constants/stringConstants';

type NavMenuPropType = {
  defaultMenuCount: number;
  isLapser?: boolean;
};

const NavMenu = ({ defaultMenuCount, isLapser }: NavMenuPropType) => {
  const { initialLaunchData, translations, appConfig } = useAppStore();
  const router = useRouter();
  const headerStrings = translations?.common;
  const innerWidth = appConfig?.deviceWidth as number;
  const isMobileScreen = innerWidth < DEVICE_WIDTH_CONSTANTS.deviceWidth1200;

  let apiMenuList: object = {};

  if (initialLaunchData) {
    const menuOptions = initialLaunchData?.country_config?.menu_options;
    if (Array.isArray(menuOptions)) {
      apiMenuList = menuOptions.map((menuOption) => menuOption.name);
    }
  }

  const isPremiumFlag =
    initialLaunchData?.country_config?.premium_menu === 'yes';
  const urlPath = router.asPath;
  const menuList = Object.values(apiMenuList);
  let moreMenuItems: Array<DynamicObject> = [];
  let menuDetails = getMenuDetails(menuList, headerStrings);
  if (
    !isServer &&
    getSessionStorage(PARTNER_NAME) &&
    getSessionStorage(PARTNER_NAME) === PartnerPlatforms.TATASKY_PARTNER &&
    menuDetails.length > 0
  ) {
    menuDetails = menuDetails.filter((item: DynamicObject) => {
      // Live TV ,News, Eduara,Music and Zeeplex not part of tataplay offering
      return !removeTelcoUserMenuList.includes(item.link);
    });
  }
  let menuItems = menuDetails;
  if (!isMobileScreen && menuDetails.length > 0) {
    menuItems = menuDetails.slice(0, defaultMenuCount);
    moreMenuItems = menuDetails.slice(defaultMenuCount);
  }

  const navigationHandler = (
    data: DynamicObject,
    index: number,
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    if (event) {
      event.preventDefault();
    }
    const { link, element, elementName } = data;
    navMenuMixpanelEvent(element, elementName, index + 1);

    if (link === NavMenuLinks.STORIES) {
      window.location.href = `${globalUrlHelper(ZEEKANNADA_NEWS_URL, true)}`;
    } else if (link === NavMenuLinks.ARTICLES) {
      window.location.href = `${globalUrlHelper(ARTICLES_NEWS_URL, true)}`;
    } else {
      window.location.href = link;
    }
  };

  const listItem = (data: DynamicObject, index: number, moreMenu: boolean) => {
    const elementName = (NavMenuItemDescription as DynamicObject)[
      data.elementName
    ];
    let element = '';
    let showRedDot = false;
    if (data.elementName === NavMenuElements.PREMIUM) {
      showRedDot = !!isLapser;
      if (isPremiumFlag) {
        element = headerStrings.MENU_PREMIUM;
      } else {
        element = headerStrings.MENU_EXCLUSIVE;
      }
    } else {
      element = data.element;
    }
    const isCorrectMenuItemActive = getActiveMenuItem(data.link, urlPath);
    return (
      <li
        css={menuItemsWrapper(moreMenu, isCorrectMenuItemActive)}
        key={index}
        data-testid={`${data.elementName.toLowerCase()}-nav-btn`}>
        <a
          css={[
            selectedItemStyle(moreMenu, isCorrectMenuItemActive),
            showRedDot && redDot
          ]}
          href={anchorTagUrlGenerator(data.link)}
          onClick={(e) => navigationHandler(data, index, e)}
          title={elementName}>
          {element}
        </a>
      </li>
    );
  };

  return (
    <div css={navMenuWrapper} data-testid="nav-menu-container">
      <ul>
        {menuItems.map((data, index) => {
          return listItem(data, index, false);
        })}
      </ul>
      {moreMenuItems.length > 0 ? (
        <div css={moreMenuStyle} data-testid="more-menu-container">
          <ul>
            {moreMenuItems.map((data: DynamicObject, index: number) => {
              index += menuItems.length;
              return listItem(data, index, true);
            })}
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default NavMenu;
